import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControl, FormHelperText, FormLabel } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { useId } from "react";
import { Controller, get, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PickerActionBar } from "./PickerActionBar";
const toDayjs = (value)=>{
    if (!value) return null;
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed : null;
};
const toIso = (value)=>{
    if (!value?.isValid()) return null;
    return value.toDate().toISOString();
};
export const DateTimeInput = (props)=>{
    const labelId = useId();
    const errorId = useId();
    const formContext = useFormContext();
    const translation = useTranslation();
    const error = get(formContext.formState.errors, props.name);
    const testId = props['data-testid'] ?? props.name;
    return /*#__PURE__*/ _jsx(LocalizationProvider, {
        dateAdapter: AdapterDayjs,
        children: /*#__PURE__*/ _jsx(Controller, {
            control: formContext.control,
            name: props.name,
            render: ({ field })=>/*#__PURE__*/ _jsxs(FormControl, {
                    error: !!error,
                    fullWidth: props.fullWidth,
                    required: props.required,
                    size: props.size,
                    children: [
                        /*#__PURE__*/ _jsx(FormLabel, {
                            disabled: props.disabled,
                            id: labelId,
                            required: props.required,
                            children: props.label
                        }),
                        /*#__PURE__*/ _jsx(DateTimePicker, {
                            disabled: props.disabled,
                            maxDateTime: props.maxDateTime,
                            minDateTime: props.minDateTime,
                            onChange: (value)=>field.onChange(toIso(value)),
                            slotProps: {
                                actionBar: {
                                    'data-testid': `clear-${testId}`
                                },
                                textField: {
                                    error: !!error,
                                    fullWidth: props.fullWidth,
                                    inputProps: {
                                        'aria-describedby': errorId,
                                        'aria-labelledby': labelId,
                                        'data-component': 'input',
                                        'data-testid': testId
                                    },
                                    required: props.required,
                                    size: props.size
                                }
                            },
                            slots: {
                                actionBar: PickerActionBar
                            },
                            value: toDayjs(field.value)
                        }),
                        !props.hideError && /*#__PURE__*/ _jsx(FormHelperText, {
                            id: errorId,
                            children: translation.t(error?.message) || ' '
                        })
                    ]
                })
        })
    });
};
DateTimeInput.displayName = 'DateTimeInput';

//# sourceMappingURL=DateTimeInput.js.map